import PaymentsRoute from './PaymentsRoute';

export default {
  name: 'Payment Management',
  location: '/payments',
  component: PaymentsRoute,
};
